export default __webpack_public_path__ + "static/media/notification-10.7293b561.mp3";